import React from 'react';

import { LeftSide, OgItemWrapper, RightSide } from './styled';
import { type OgRuleProps } from './types';

export const RuleItemGroup = ({ left, children }: OgRuleProps) => {
	return (
		<OgItemWrapper>
			<LeftSide>{left}</LeftSide>
			<RightSide>{children}</RightSide>
		</OgItemWrapper>
	);
};
